import Button from './button';
import NoticeBar from './notice-bar';
import Badge from './badge';
import {
  TabBar,
  TabBarItem,
} from './tab-bar';
import Divider from './divider';
import Footer from './footer';
import Overlay from './overlay';
import Popup from './popup';
import Toast from './toast';
import Switch from './switch';
import Tag from './tag';
import ActionSheet from './action-sheet';
import Keyboard from './keyboard';
import AmountInput  from './amount-input';
import AmountBox from './amount-box';
import KeyboardInput  from './keyboard-input';
import List from './list';
import Locale from './locale';
import { Radio, RadioGroup } from './radio';
import Result from './result';
import HalfScreenDialog from './half-screen-dialog';
import Dialog from './dialog';
import { Tabs, TabItem } from './tabs';
import ScrollView from './scroll-view';
import FormPreview from './form-preview';
import { Step, StepItem } from './step';
import Cell, { CellGroup } from './cell';
import Avatar from './avatar';
import Picker from './picker';
import DatePicker from './date-picker';
import Tooltip from './tooltip';

export type { ActionSheetAction, ActionSheetProps } from './action-sheet';
export type { PickerProps, PickerOption, PickerFieldNames, PickerEventParams, PickerChangeEventParams } from './picker';
export type { DatePickerProps, DatePickerColumnType, DatePickerEventParams, DatePickerChangeEventParams, DatePickerFormatter, DatePickerFilter } from './date-picker';
export type { TooltipProps, TooltipArrowPosition } from './tooltip';

const components = [
  Button,
  NoticeBar,
  Badge,
  TabBar,
  TabBarItem,
  Divider,
  Footer,
  Overlay,
  Popup,
  Toast,
  Switch,
  Tag,
  ActionSheet,
  Keyboard,
  Radio,
  RadioGroup,
  AmountInput,
  AmountBox,
  KeyboardInput,
  List,
  Result,
  HalfScreenDialog,
  Dialog,
  Tabs,
  TabItem,
  ScrollView,
  FormPreview,
  Step,
  StepItem,
  Cell,
  Avatar,
  Picker,
  DatePicker,
  Tooltip,
];

const install = function (Vue) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export { showToast, hideToast } from './toast';

export { showDialog, hideDialog } from './dialog';
export type { DialogAction, DialogOptions } from './dialog';

export {
  install,
  Locale,
  Button,
  NoticeBar,
  Badge,
  TabBar,
  TabBarItem,
  Divider,
  Footer,
  Overlay,
  Popup,
  Toast,
  Switch,
  Tag,
  ActionSheet,
  Keyboard,
  Radio,
  RadioGroup,
  AmountInput,
  AmountBox,
  KeyboardInput,
  List,
  Result,
  HalfScreenDialog,
  Dialog,
  Tabs,
  TabItem,
  ScrollView,
  FormPreview,
  Step,
  StepItem,
  Cell,
  CellGroup,
  Avatar,
  Picker,
  DatePicker,
  Tooltip,
};
